import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-noti-followers',
  templateUrl: './noti-followers.component.html',
  styleUrls: ['./noti-followers.component.scss'],
})
export class NotiFollowersComponent implements OnInit {
  notificationList:any = [];
  constructor() { }

  ngOnInit() {
    this.notificationList = [
      {
        message:"Lorena Quijano ha solicitado seguirte",
        icon:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAAAAAAALAAAAAABAAEAAAICTAEAOw=="
      },
      {
        message:"Pablo Montoya comenzó a seguirte",
        icon:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAAAAAAALAAAAAABAAEAAAICTAEAOw=="
      },
      {
        message:"Enrique Guzmán ha solicitado seguirte",
        icon:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAAAAAAALAAAAAABAAEAAAICTAEAOw=="
      }
    ];
  }
  userOptions(){

  }

}
